import moment from 'moment';
import Photo from '../../../../sharedComponents/photo/Photo.vue';
import QrCodeScanner from '../../../../sharedComponents/qr-code-scanner/QrCodeScanner.vue';

export default {
  name: 'IndividualDocInfoPanel',
  components: { QrCodeScanner, Photo },
  props: ['form', 'isEditable'],
  data() {
    return {
      // Состояние меню для поля "Дата продажи
      saleDateMenu: false,
      // Правила валидации формы
      rules: {
        required: value => !!value || 'Поле должно быть заполнено',
      },
      // Максимальное значение даты
      maxDate: moment().format('YYYY-MM-DD'),
      // Состояние меню для поля "Время чека"
      ticketTimeMenu: false,
      // Процесс инициализации qr-кода
      sendingQr: false,
      // Проверен ли чек?
      checkQr: false,
      // qr-код
      scanQrCode: {
        openModal: false,
      },
    };
  },
  computed: {
    // Процесс выполнения запроса к серверу
    loading() {
      return this.$store.state.loading;
    },
    // Проверка, отправлен ли на проверку qr-код
    isSendQr() {
      return (
        this.isEditable
        && this.form.date_setup_local
        && this.form.qrcode_t
        && this.buildQr
        && !this.checkQr
        && this.form.qrcode_s
        && this.form.qrcode_fn
        && this.form.qrcode_i
        && this.form.qrcode_fp
        && (this.sale && this.sale.tickets && this.sale.tickets.length > 0
          ? this.sale.tickets[0].qrcode !== this.buildQr
          : true)
      );
    },
    // Сформированный qr-код
    buildQr() {
      let qrcode = '';
      if (this.form.date_setup && this.form.qrcode_t) {
        qrcode = `t=${moment(
          `${this.form.date_setup_local} ${this.form.qrcode_t}`,
          'DD.MM.YYYY HH:mm',
        ).format('YYYYMMDD[T]HHmm')}`;
      }
      qrcode += `&s=${this.form.qrcode_s}`;
      qrcode += `&fn=${this.form.qrcode_fn}`;
      qrcode += `&i=${this.form.qrcode_i}`;
      qrcode += `&fp=${this.form.qrcode_fp}`;
      qrcode += `&n=${this.form.qrcode_n}`;

      return qrcode;
    },
  },
  watch: {
    checkQr(value) {
      this.$emit('checkQr', value);
    },
  },
  methods: {
    // Проверка билета
    checkTicket() {
      this.sendingQr = true;
      const app = this;
      app.$store.getters.axl
        .post('fns/api/tickets/check', {
          qrcode: app.buildQr,
          sale_id: this.saleID,
        })
        .then((response) => {
          const { isCheck, message } = response.data;

          app.checkQr = isCheck;
          const type = app.checkQr ? 'ShowInfo' : 'ShowError';

          app.$store.dispatch(type, message);
        })
        .catch(error => app.$store.dispatch('HandleError', error))
        .finally(() => {
          this.sendingQr = false;
        });
    },
    /**
     * Обработка ошибки сканирования qr-кода, закрыть окошко
     * @param error
     */
    stopQrScan(error) {
      this.$store.dispatch('ShowErrorMessage', error);
      this.scanQrCode.openModal = false;
    },
    /**
     * Получение чека
     * @param qrcode
     */
    detectQr(qrcode) {
      this.sendingQr = true;
      this.$store.getters.axl
        .post('fns/api/tickets/is-valid', {
          qrcode: qrcode.toLowerCase(),
          sale_id: this.saleID,
        })
        .then((response) => {
          const date = moment(response.data.t);
          this.form.qrcode_i = response.data.fd;
          this.form.qrcode_fn = response.data.fn;
          this.form.qrcode_fp = response.data.fp;
          this.form.qrcode_n = response.data.n;
          this.form.qrcode_s = response.data.s;
          this.form.date_setup = date.format('YYYY-MM-DD');
          this.form.qrcode_t = date.format('HH:mm');
          this.checkQr = false;
        })
        .catch(error => this.$store.dispatch('HandleError', error))
        .finally(() => {
          this.scanQrCode.openModal = false;
          this.sendingQr = false;
        });
    },
  },
};
